<template>
    <footer class="hc-footer">
        <div class="hc-cntr">
            <div class="hc-footer__container">
                <img alt="Hilton logo" :src="footer_logo" width="125" height="64" decoding="async" data-nimg="1"
                    loading="lazy" style="color:transparent">
                <ul class="hc-footer__column" v-if="device === 'pc'">
                    <li>
                        <span class="hc-footer__header">{{ $t('footer.hiltonCareers') }}</span>
                        <ul class="hc-footer__submenu">
                            <li>
                                <router-link to="/lifeAtHilton">
                                    {{ $t('footer.lifeAtHilton') }}
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/benefits">
                                    {{ $t('footer.benefits') }}
                                </router-link>
                            </li>
                            <li>
                                <a href="https://hilton-careers-next.go-vip.net">
                                    {{ $t('footer.locations') }}
                                </a>
                            </li>
                            <li>
                                <router-link to="/searchJob">
                                    {{ $t('footer.searchJobs') }}
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
                <div class="hc-footer__wrap">
                    <div v-if="device === 'pc'" :class="`follow-wechat ${showFollowWechat ? 'show' : ''}`">
                        <div class="title">
                            {{ currentSocial.title }}
                            <br>
                            <span v-if="currentSocial.title1">{{ currentSocial.title1 }}</span>
                        </div>
                        <div class="sub-title">
                            {{ currentSocial.subTitle }}
                        </div>
                        <img width="140" height="140" :src="currentSocial.qrcode" alt="search jobs">
                    </div>
                    <ul class="hc-footer__social hc-footer__column">
                        <li>
                            <span class="hc-footer__header" >{{ $t('footer.social') }}</span>
                            <ul class="hc-footer__submenu hc-footer__social-items">
                                <li v-for="(item,index) in socialList" :key="index" class="img-item"
                                    @mouseenter="mouseenterHandle(index)" @mouseleave="mouseleaveHandle"
                                    @click="mbClickHandle(index)">
                                    <img :src="item.icon" alt="Glassdoor" width="40" height="40">
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <hr>
            <div class="hc-footer__legal" v-if="device === 'pc'">
                <span>© 2025 Hilton</span>
                <div class="hc-footer__legal-item">
                    <a href="https://beian.miit.gov.cn/">沪ICP备2024042120号-2</a>
                    <a class="non-line" href="https://beian.mps.gov.cn/#/query/webSearch">沪公网安备31010102005515号</a>
                </div>
            </div>
            <div class="hc-footer__legal" v-else>
                <a href="https://beian.miit.gov.cn/">沪ICP备2024042120号-2</a>
                <a href="https://beian.mps.gov.cn/#/query/webSearch">沪公网安备31010102005515号</a>
                <span>© {{ year }} Hilton</span>
            </div>
        </div>
        <Overlay v-if="device === 'mb'" :show="showFollowWechat" @click="showFollowWechat = false" z-index="100">
            <div class="mb-follow-wrapper">
                <div :class="`follow-wechat ${showFollowWechat ? 'show' : ''}`">
                    <div class="title">
                        {{ currentSocial.title }}
                        <br>
                        <span v-if="currentSocial.title1">{{ currentSocial.title1 }}</span>
                    </div>
                    <div class="sub-title">
                        {{ currentSocial.subTitle }}
                    </div>
                    <img width="184" height="184" :src="currentSocial.qrcode" alt="search jobs">
                </div>
            </div>
        </Overlay>
    </footer>
</template>

<script setup>
import footer_logo from '@/assets/image/footer/footer-logo.webp'
import footer_bili from '@/assets/image/footer/bili.png'
import footer_douyin from '@/assets/image/footer/douyin.png'
import footer_redbook from '@/assets/image/footer/redbook.png'
import footer_video from '@/assets/image/footer/video.png'
import footer_wechart from '@/assets/image/footer/wechart.png'
import footer_miniProgram from '@/assets/image/footer/miniProgram.png'
import job_wechat from '@/assets/image/footer/job-wechat.png'
import job_redbook from '@/assets/image/footer/job-redbook.png'
import job_douyin from '@/assets/image/footer/job-douyin.png'
import job_video from '@/assets/image/footer/job-video.png'
import job_bili from '@/assets/image/footer/job-bili.png'
import job_miniProgram from '@/assets/image/footer/job-miniProgram.jpg'

import { inject, ref, computed } from "vue";
import { Overlay } from 'vant';
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();
const device = inject("device");

const showFollowWechat = ref(false)

const year = new Date().getFullYear()

const socialList = computed(()=>{
    return [
        {
            title: t('footer.wechart'),
            subTitle: t('footer.followSuTitle'),
            icon: footer_wechart,
            qrcode: job_wechat,
        }, {
            title: t('footer.redbook'),
            subTitle: t('footer.followSuTitle'),
            icon: footer_redbook,
            qrcode: job_redbook,
        }, {
            title: t('footer.douyin'),
            subTitle: t('footer.followSuTitle'),
            icon: footer_douyin,
            qrcode: job_douyin,
        }, {
            title: t('footer.video'),
            subTitle: t('footer.followSuTitle'),
            icon: footer_video,
            qrcode: job_video,
        }, {
            title: t('footer.bili'),
            subTitle: t('footer.followSuTitle'),
            icon: footer_bili,
            qrcode: job_bili,
        }, {
            title: t('footer.miniProgram'),
            // title1: t('footer.miniProgram1'),
            subTitle: t('footer.miniProgram1'),
            icon: footer_miniProgram,
            qrcode: job_miniProgram,
        }
    ]
}) 
const currentSocial = ref({
    title: '',
    subTitle:'',
    icon: '',
    qrcode: '',
})
const mouseenterHandle = (index) => {
    if (device.value === 'pc'){
        showFollowWechat.value = true;
        currentSocial.value = socialList.value[index]
    }
}
const mouseleaveHandle = () =>{
    if (device.value === 'pc'){
        showFollowWechat.value = false;
        currentSocial.value = {
            title: '',
            subTitle: '',
            icon: '',
            qrcode: '',
        }
    }
}
const mbClickHandle = (index) => {
    if(device.value === 'mb'){
        currentSocial.value = socialList.value[index]
        showFollowWechat.value = true
    }
}

</script>

<style lang='scss' scoped>
.hc-footer__legal{
    display: flex;
    justify-content: space-between;
}
.non-line:after{
    content: "";
        margin: 0
}
@media (max-width: 1023px) {
    .hc-footer__legal a:after {
        content: "";
        margin: 0
    }
    .hc-cntr{
        padding: 0;
    }
        .hc-footer__social {
            overflow: auto;
            width: 100%;
            .hc-footer__social-items {
                gap: 18px;
            }
        }
}

.hc-footer__wrap {
    position: relative;

    .follow-wechat {
        position: absolute;
        left: -230px;
        background-color: #fff;
        padding: 24px;
        text-align: center;
        transition: all 0.3s ease-in-out;
        opacity: 0;
        width: 220px;
        display: none;
        .title {
            color: var(--hc-color--darkblue);
            font-size: 1.125rem;
        }
        .sub-title {
            color: var(--hc-color--darkblue);
            font-size: 0.85rem;
            margin-bottom: 20px;
        }
    }

    .follow-wechat.show {
        opacity: 1;
        display: block;
    }

    .img-item {
        cursor: pointer;
    }
}
.mb-follow-wrapper{
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .follow-wechat {
            background-color: #fff;
            padding: 32px;
            text-align: center;
            width: 277px;
            .title {
                color: var(--hc-color--darkblue);
                font-size: 1.625rem;
            }
    
            .sub-title {
                color: var(--hc-color--darkblue);
                font-size: 1rem;
                margin-bottom: 20px;
            }
        }
}
</style>